import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";

// GET =>  GET APPOINTMENTS
export const getAppointmentsService = createAsyncThunk(
  "appointments/getAppointmentsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.appointmentsURL, {
        params: { ...params },
      });
      console.log(response);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE APPOINTMENT SERVICE
export const createAppointmentService = createAsyncThunk(
  "appointments/createAppointmentService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.appointmentsURL, data, {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// DELETE =>  DELETE APPOINTMENT SERVICE
export const deleteAppointmentSService = createAsyncThunk(
  "appointmentS/deleteAppointmentSService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.appointmentsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE APPOIN SERVICE
export const updateAppointmentSService = createAsyncThunk(
  "appointmentS/updateAppointmentSService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.appointmentsURL}/${params?.id}`,
        params?.data,
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET => GET  SERVICE BY ID
export const getAppointmentByIdService = createAsyncThunk(
  "appointmentS/getAppointmentByIdService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.appointmentsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
